import { OnChanges, Component, ContentChildren, Directive, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, TemplateRef, ViewChild, ViewChildren, SimpleChanges } from '@angular/core';
import { CarouselItemDirective } from './carousel-item.directive';
import { animate, AnimationBuilder, AnimationFactory, AnimationPlayer, style } from '@angular/animations';
import { ControllerService } from '../shared/services/controller.service';


@Directive({
    selector: '.carousel-item',
    standalone: false
})

export class CarouselItemElement {
}

@Component({
    selector: 'carousel',
    exportAs: 'carousel',
    templateUrl: './carousel.component.html',
    styleUrls: ['./carousel.component.scss'],
    standalone: false
})
export class CarouselComponent implements OnInit, OnChanges {

  @ContentChildren(CarouselItemDirective) items : QueryList<CarouselItemDirective>;
  @ViewChildren(CarouselItemElement, { read: ElementRef }) private itemsElements : QueryList<ElementRef>;
  @ViewChild('carousel', { static: false }) private carousel : ElementRef;
  @Output() iveSeenEverything: EventEmitter<any> = new EventEmitter();
  @Input() timing = '250ms ease-in';
  @Input() showControls = true;
  @Input() itemHeight: number = 50
  @Input() page: number = 0
  private player : AnimationPlayer;
  private currentSlide = 0;

  private sliding = false

  getCarouselWrapperStyle(){
    return {height:this.itemHeight + 'px', 'border-radius': '30px'}
  }

  haveNext(){
    return this.currentSlide + 1 < this.items.length
  }

  havePrev(){
    return this.currentSlide > 0
  }

  next() {
    if( this.sliding ) return


    this.sliding = true;

    if( this.currentSlide + 1 === this.items.length ) return;
    if( this.currentSlide + 1  === this.items.length -1 ){
      this.iveSeenEverything.emit(true)
    }
    this.currentSlide = (this.currentSlide + 1) % this.items.length;
    const offset = this.currentSlide * this.itemHeight;
    const myAnimation : AnimationFactory = this.buildAnimation(offset, undefined);
    this.player = myAnimation.create(this.carousel.nativeElement);
    this.player.play();

    window.setTimeout( () => {
      this.controller.next()
      this.sliding = false
    }, 250)
  }

  private buildAnimation( offset, timing ) {
    return this.builder.build([
      animate( timing != undefined ? timing : this.timing, style({ transform: `translateY(-${offset}px)` }))
    ]);
  }

  prev() {
    if( this.currentSlide === 0 ) return;
    if( this.sliding ) return

    this.sliding = true

    this.currentSlide = ((this.currentSlide - 1) + this.items.length) % this.items.length;
    const offset = this.currentSlide * this.itemHeight;

    const myAnimation : AnimationFactory = this.buildAnimation(offset, undefined);
    this.player = myAnimation.create(this.carousel.nativeElement);
    this.player.play();

    window.setTimeout( () => {
      this.controller.back()
      this.sliding = false
    }, 250)
  }

  constructor( private builder : AnimationBuilder, public controller: ControllerService ) {
  }

  ngOnInit() {
  }

  ngOnChanges( changes : SimpleChanges ){

    if( !this.items ){
      return
    }

    this.page = changes.page.currentValue

    this.currentSlide = this.page -1
      this.currentSlide = (this.currentSlide + 1) % this.items.length;
      const offset = this.currentSlide * this.itemHeight;

      const myAnimation : AnimationFactory = this.buildAnimation(offset, undefined);
      this.player = myAnimation.create(this.carousel.nativeElement);
      this.player.play();

      if( this.currentSlide   === this.items.length -1 ){
        this.iveSeenEverything.emit(true)
      }


  }


  ngAfterViewInit(){

    if( this.page > 0 ){
      this.currentSlide = this.page -1
      this.currentSlide = (this.currentSlide + 1) % this.items.length;
      const offset = this.currentSlide * this.itemHeight;

      const myAnimation : AnimationFactory = this.buildAnimation(offset, 0);
      this.player = myAnimation.create(this.carousel.nativeElement);
      this.player.play();


    }

    if( this.currentSlide === this.items.length -1 ){
      this.iveSeenEverything.emit(true)
    }

  }

}
